import React from 'react';
import './CommonBanner.css';

const CommonBanner = ({
  product_banner,
  product_banner_mobile,
  title,
  subtitle,
  eyebrow = "MAYA ARCHIVE"
}) => {
  const imgSrc = product_banner || product_banner_mobile || "";

  return (
    <section className="common-banner-section" aria-label={title || "Banner"}>
      {/* RESPONSIVE PICTURE MEDIA */}
      {imgSrc && (
        <picture className="common-banner-media">
          {product_banner_mobile && (
            <source media="(max-width: 768px)" srcSet={product_banner_mobile} />
          )}
          <img
            src={imgSrc}
            alt={title || "Collection Banner"}
            loading="eager"
            decoding="async"
          />
        </picture>
      )}

      {/* CINEMATIC AMBIENT SCRIM */}
      <div className="common-banner-scrim" aria-hidden="true" />

      {/* EDITORIAL CONTENT */}
      <div className="common-banner-content">
        {eyebrow && (
          <div className="common-banner-eyebrow">
            <span className="common-banner-eyebrow-line" aria-hidden="true" />
            <span>{eyebrow}</span>
            <span className="common-banner-eyebrow-line" aria-hidden="true" />
          </div>
        )}

        {title && (
          <h1 className="common-banner-title">{title}</h1>
        )}

        {subtitle && (
          <p className="common-banner-subtitle">{subtitle}</p>
        )}
      </div>
    </section>
  );
};

export default React.memo(CommonBanner);